import { C3_LS3_NON_PROD, C3_LS3_PROD } from '../utils/constants';
import * as fetch from '../utils/fetch';
import { PROD_RTES } from '../utils/validators';

export type LoggerRequestBody = {
  level: string;
  message: string;
};
export default class LoggerApi {
  static makePostCall(env: string, body: LoggerRequestBody): void {
    const url = PROD_RTES.includes(env.toUpperCase()) ? C3_LS3_PROD : C3_LS3_NON_PROD;
    void fetch
      .post<LoggerRequestBody, any>(url, body, { headers: { 'Content-Type': 'application/json' } })
      .catch((err) => console.log('encountered issue', err));
  }
}
